import { useGetIcon } from '@src/main/ui/components/common/Icon/hooks/useGetIcon';
import { FC } from 'react';
import styles from './Icon.module.scss';
import { IconId } from './IconId';

interface IconProps {
  iconId: IconId;
  fontSize?: string;
}

const defaultProps = { fontSize: undefined };

const Icon: FC<IconProps> = ({ iconId, fontSize }) => (
  <span className={styles.icon} style={fontSize ? { fontSize } : undefined}>
    {useGetIcon(iconId)}
  </span>
);

Icon.defaultProps = defaultProps;

export default Icon;
